
<span class="i-arrow-block" [class]="textColor">
    <ng-container *ngIf="isRate; else BySale">
          1 {{ rateCoin.binance_ticker }} = {{ exchangeRate | currency: '' : '' : '.0-' + exchangeCoin.precision }} {{ exchangeCoin.binance_ticker }}
    </ng-container>
    <ng-template #BySale>
          1 {{ exchangeCoin.binance_ticker }} = {{ price | currency: '' : '' : '.0-' + rateCoin.precision}} {{ rateCoin.binance_ticker }}
    </ng-template>
  </span>
